import { connect } from 'react-redux'
import KanBoUserPicker from './KanBoUserPicker'
import {
  addArray as addUsersArray
} from 'store/redux/users'

export default connect(
  null,
  {
    addUsersArray
  },
  null,
  {
    forwardRef: true
  }
)(KanBoUserPicker)

